import { CSSProperties, FC, useEffect, useState } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface MiddleDotProps {
    horizontalMargin?: string | number | undefined;
    margin?: string | number | undefined;
    styles?: CSSProperties | undefined;
}

const MiddleDot: FC<MiddleDotProps> = ({ horizontalMargin = '1rem', margin, styles }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    return (
        <>
            <span
                style={{
                    color: token.colorTextTertiary,
                    fontWeight: 'bold',
                    margin: margin ? margin : `0 ${horizontalMargin}`,
                    ...styles,
                }}
            >
                &middot;
            </span>
        </>
    );
};

export default MiddleDot;
